import React, {useState} from 'react';
import {OrdersProvider, useOrdersState} from './../../state/index';
import OrdersTable from './Table/OrdersTable';
import OrderDetails from "./OrderDetails";

export const OrdersAppInner = () => {
    const {isLoading, handleOrderDownload, handleOrderClick, selectedOrder, handleBack, judete, handleReorder} = useOrdersState();
    const [downloadingOrderId, setDownloadingOrderId] = useState(null);

    const columns = React.useMemo(
        () => [
            {
                Header: 'ERP ID',
                accessor: 'col1',
            },
            {
                Header: 'ID Comanda',
                accessor: 'col2',
            },
            {
                Header: 'Client',
                accessor: 'col3',
            },
            {
                Header: 'Adresa Livrare',
                accessor: 'col4',
                Cell: ({ row }) => {
                    const order = row.original.order;
                    return (
                        <div>
                            <span style={{ fontWeight: 'bold' }}>{order.SHIPPING.NAME || ''}</span>
                            <span> - {order.SHIPPING.CITY || ''}, {order.SHIPPING.ADDRESS || ''}, </span>
                            <span>{judete[order.SHIPPING.DISTRICT1 || ''] || order.SHIPPING.DISTRICT1 || ''}</span>
                        </div>
                    );
                },
            },
            {
                Header: 'Data Comanda',
                accessor: 'col5',
            },
            {
                Header: 'Total cu TVA',
                accessor: 'col6',
            },
            {
                Header: 'Status',
                accessor: 'col7',
            },
            {
                Header: 'Numar AWB',
                accessor: 'col8',
                Cell: ({cell: {value}}) => (
                    <div dangerouslySetInnerHTML={{__html: value}}/>
                ),
            },

            {
                Header: 'Vezi comanda',
                Cell: ({row}) => (
                    <>
                        <button className="action-default" onClick={() => handleOrderClick(row.original.order)}>
                            Detalii
                        </button>
                    </>
                ),
            },
            {
                Header: 'Factura',
                Cell: ({row}) => {
                    const orderId = row.original.col1;
                    const orderStatus = row.original.order.SALDOC.STATUSNAMELIVRARE;
                    const isDownloading = downloadingOrderId === orderId;

                    const canDownloadInvoice = orderStatus === 'Complet';

                    if (!canDownloadInvoice) {
                        return <span>Factura nu a fost emisă</span>;
                    }

                    return (
                        <button
                            className="action-default"
                            onClick={() => {
                                setDownloadingOrderId(orderId);
                                handleOrderDownload(orderId)
                                    .then(() => {
                                        console.log('Download successful');
                                    })
                                    .catch(error => {
                                        console.error('Download failed:', error);
                                    })
                                    .finally(() => {
                                        setDownloadingOrderId(null);
                                    });
                            }}
                            disabled={isDownloading}
                        >
                            {isDownloading ? 'Așteptați...' : 'Download'}
                        </button>
                    );
                },
            },
            {
                Header: 'Reorder',
                Cell: ({row}) => {
                    const order = row.original.order;
                    const orderId = order.SALDOC.FINCODE;

                    return (
                        <button
                            className="action-default"
                            onClick={() => {
                                console.log('Trying to reorder Magento order:', orderId);
                                handleReorder(orderId);
                            }}
                        >
                            Reorder
                        </button>
                    );
                },
            }
        ],
        [downloadingOrderId, handleOrderDownload]
    );

    return (
        <div>
            {isLoading && <div className="loading-overlay">Se incarca...</div>} {/*Loading overlay*/}

            {!selectedOrder && (
                <OrdersTable
                    columns={columns}
                />
            )}
            {selectedOrder && (
                <OrderDetails
                    order={selectedOrder}
                    onBack={handleBack}
                />
            )}
        </div>
    );
};

export const OrdersApp = ({ config }) => {
    return (
        <OrdersProvider config={config}>
            <OrdersAppInner />
        </OrdersProvider>
    );
}
